"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["action"];
const _hoisted_2 = { class: "flex sm:flex-row flex-col gap-5" };
const _hoisted_3 = {
    key: 0,
    class: "text-center w-full"
};
const _hoisted_4 = /*#__PURE__*/ (0, vue_2.createElementVNode)("p", { class: "mb-1 text-lg" }, "Your basket is currently empty.", -1);
const _hoisted_5 = /*#__PURE__*/ (0, vue_2.createElementVNode)("p", { class: "mb-4 text-lg" }, "Why not have a look to see what we have on?", -1);
const _hoisted_6 = ["href"];
const _hoisted_7 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "What's on", -1);
const _hoisted_8 = { key: 1 };
const _hoisted_9 = /*#__PURE__*/ (0, vue_2.createStaticVNode)("<div class=\"grid grid-cols-10 divide-x divide-solid divide-beige-400 border-b border-beige-400\"><div class=\"col-span-5 uppercase font-semibold tracking-wider p-4\">Product</div><div class=\"col-span-2 uppercase font-semibold tracking-wider p-4 text-center\">Price</div><div class=\"col-span-1 uppercase font-semibold tracking-wider p-4 text-center\">QTY</div><div class=\"col-span-2 uppercase font-semibold tracking-wider p-4 text-center\">Total</div></div>", 1);
const _hoisted_10 = { class: "grid grid-cols-10 divide-x divide-solid divide-beige-400" };
const _hoisted_11 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "col-span-5" }, null, -1);
const _hoisted_12 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "col-span-3 flex justify-start items-center font-semibold p-5 tracking-wider uppercase no-divider-x" }, " Total ", -1);
const _hoisted_13 = { class: "col-span-2 flex justify-center items-center font-semibold p-5 tracking-wider" };
const _hoisted_14 = /*#__PURE__*/ (0, vue_2.createStaticVNode)("<div class=\"w-full flex flex-col items-end\"><label for=\"promotion_code\" class=\"w-full md:w-6/12 font-semibold p-5 tracking-wider uppercase\"> Coupon Code <span class=\"text-xs\">(optional - case sensitive)</span></label><input type=\"text\" name=\"promotion_code\" class=\"input w-full md:w-6/12\"></div><div class=\"w-full flex flex-col mt-10\"><label for=\"notes\" class=\"font-semibold p-5 tracking-wider uppercase\"> Additional Notes <span class=\"text-xs\">(optional)</span></label><textarea class=\"input\" name=\"notes\" id=\"notes\" cols=\"30\" rows=\"5\" placeholder=\"Notes about your order, e.g. if you&#39;re purchasing on behalf of someone else, or any special requirements\"></textarea></div>", 2);
const _hoisted_16 = {
    key: 0,
    class: "w-full flex flex-col items-center bg-beige-400 p-10 my-10"
};
const _hoisted_17 = /*#__PURE__*/ (0, vue_2.createStaticVNode)("<h3 class=\"uppercase text-3xl md:text-6xl text-center font-black tracking-tighter leading-squished md:leading-squished mb-10\"> Checkout </h3><p class=\"prose prose-lg max-w-none text-center leading-relaxed mb-10\"> Before you can checkout, we need your email address and phone number so we can send you details of your order </p><div class=\"flex flex-col m-5\"><div><label for=\"basket_tc\">I have read and agree to the website <a class=\"underline\" href=\"/checkout-tcs\">terms and conditions</a></label><input class=\"checkbox\" type=\"checkbox\" required name=\"basket_tc\" id=\"basket_tc\"></div></div>", 3);
const _hoisted_20 = { class: "flex sm:flex-row flex-col gap-5 justify-between w-full max-w-xl mb-5" };
const _hoisted_21 = { class: "flex sm:flex-row flex-col gap-5 justify-between w-full max-w-xl mb-5" };
const _hoisted_22 = { class: "flex sm:flex-row flex-col gap-5 justify-between w-full max-w-xl" };
const _hoisted_23 = ["disabled"];
const _hoisted_24 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "Checkout", -1);
const _hoisted_25 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "flex justify-end" }, null, -1);
const vue_3 = require("vue");
const Basket_1 = require("../../stores/Basket");
const pinia_1 = require("pinia");
const Money_1 = require("../../src/Money");
const BasketListItem_vue_1 = __importDefault(require("./BasketListItem.vue"));
const Route_1 = __importDefault(require("../../src/Route"));
// Note that we don't need to fetch the basket details in the store here as
// they get fetched on every page from the nav basket icon component
exports.default = (0, vue_1.defineComponent)({
    __name: 'BasketShow',
    setup(__props) {
        const store = (0, Basket_1.useBasketStore)();
        const name = (0, vue_3.ref)('');
        const email = (0, vue_3.ref)('');
        const phone = (0, vue_3.ref)('');
        const { products, total } = (0, pinia_1.storeToRefs)(store);
        /**
         * Checkout Button Enabled
         *
         * Checks if the name, email and phone inputs have data entered. If both values
         * are above 0 we can assume the required information has been entered to
         * complete the checkout process.
         *
         * @returns Boolean
         */
        function checkoutBtnEnabled() {
            if (name.value.length > 0 && email.value.length > 0 && phone.value.length > 0) {
                return false;
            }
            return true;
        }
        return (_ctx, _cache) => {
            const _component_button_icon = (0, vue_2.resolveComponent)("button-icon");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("form", {
                action: (0, vue_2.unref)(Route_1.default)('checkout.create')
            }, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    ((0, vue_2.unref)(products).length === 0)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                            _hoisted_4,
                            _hoisted_5,
                            (0, vue_2.createElementVNode)("p", null, [
                                (0, vue_2.createElementVNode)("a", {
                                    href: (0, vue_2.unref)(Route_1.default)('whats-on.index'),
                                    class: "button button-outlined button-muted-purple-800 has-icon"
                                }, [
                                    (0, vue_2.createVNode)(_component_button_icon),
                                    _hoisted_7
                                ], 8, _hoisted_6)
                            ])
                        ]))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, [
                            _hoisted_9,
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(products), (product) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(BasketListItem_vue_1.default, {
                                    product: product,
                                    key: product.id
                                }, null, 8, ["product"]));
                            }), 128)),
                            (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                _hoisted_11,
                                _hoisted_12,
                                (0, vue_2.createElementVNode)("div", _hoisted_13, (0, vue_2.toDisplayString)((0, vue_2.unref)(Money_1.formatMoney)((0, vue_2.unref)(total))), 1)
                            ]),
                            _hoisted_14,
                            ((0, vue_2.unref)(products).length > 0)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_16, [
                                    _hoisted_17,
                                    (0, vue_2.createElementVNode)("div", _hoisted_20, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            type: "text",
                                            required: "",
                                            name: "name",
                                            class: "input w-full",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((name).value = $event)),
                                            placeholder: "Name..."
                                        }, null, 512), [
                                            [vue_2.vModelText, name.value]
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_21, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            type: "tel",
                                            required: "",
                                            name: "phone",
                                            class: "input w-full",
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((phone).value = $event)),
                                            placeholder: "Phone Number..."
                                        }, null, 512), [
                                            [vue_2.vModelText, phone.value]
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_22, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            type: "email",
                                            required: "",
                                            name: "email",
                                            class: "input w-full",
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((email).value = $event)),
                                            placeholder: "Email address..."
                                        }, null, 512), [
                                            [vue_2.vModelText, email.value]
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("button", {
                                        type: "submit",
                                        class: "button button-yellow-500 hover:button-mutedpurple-800 my-5 has-icon disabled:opacity-75",
                                        disabled: checkoutBtnEnabled()
                                    }, [
                                        (0, vue_2.createVNode)(_component_button_icon, { "icon-class": "text-red" }),
                                        _hoisted_24
                                    ], 8, _hoisted_23)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            _hoisted_25
                        ]))
                ])
            ], 8, _hoisted_1));
        };
    }
});
